import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import Button from './Button';

export default function InstallPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  useEffect(() => {
    // Escuchar el evento beforeinstallprompt
    const handler = (e) => {
      // Prevenir que Chrome 67 y anteriores muestren el prompt automáticamente
      e.preventDefault();
      // Guardar el evento para poder dispararlo más tarde
      setDeferredPrompt(e);
      // Mostrar el botón de instalación
      setShowInstallPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Verificar si la app ya está instalada
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowInstallPrompt(false);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      return;
    }

    // Mostrar el prompt de instalación
    deferredPrompt.prompt();

    // Esperar a que el usuario responda al prompt
    const { outcome } = await deferredPrompt.userChoice;
    
    console.log(`Usuario respondió al prompt de instalación: ${outcome}`);

    // Limpiar el prompt guardado
    setDeferredPrompt(null);
    setShowInstallPrompt(false);
  };

  const handleDismiss = () => {
    setShowInstallPrompt(false);
    // Guardar en localStorage que el usuario rechazó la instalación
    localStorage.setItem('pwa-install-dismissed', 'true');
  };

  // Verificar si el usuario ya rechazó el prompt
  useEffect(() => {
    const dismissed = localStorage.getItem('pwa-install-dismissed');
    if (dismissed === 'true') {
      setShowInstallPrompt(false);
    }
  }, []);

  return (
    <AnimatePresence>
      {showInstallPrompt && (
        <div className="fixed bottom-120u left-0 right-0 z-50 flex justify-center pointer-events-none">
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.3 }}
            className="bg-navy border-2u border-blue rounded-30u
                       p-40u shadow-2xl
                       flex flex-col gap-24u items-center
                       max-w-600u pointer-events-auto"
          >
            <div className="text-white text-32u font-light text-center">
              Install this app on your device for quick access
            </div>
            
            <div className="flex gap-24u">
              <Button
                onClick={handleInstallClick}
                className="px-48u py-24u text-24u bg-blue hover:bg-royal transition-colors"
              >
                Install
              </Button>
              
              <Button
                onClick={handleDismiss}
                className="px-48u py-24u text-24u bg-gray-600 hover:bg-gray-700 transition-colors"
              >
                Not now
              </Button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
